'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = count;

var _actions = require('./actions');

var _colorManipulator = require('material-ui/utils/colorManipulator');

var _spacing = require('material-ui/styles/spacing');

var _spacing2 = _interopRequireDefault(_spacing);

var _zIndex = require('material-ui/styles/zIndex');

var _zIndex2 = _interopRequireDefault(_zIndex);

var _colors = require('material-ui/styles/colors');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var initialState = {
  spacing: _spacing2.default,
  zIndex: _zIndex2.default,
  fontFamily: 'Roboto, sans-serif',
  palette: {
    primary1Color: _colors.cyan500,
    primary2Color: _colors.cyan700,
    primary3Color: _colors.lightBlack,
    accent1Color: _colors.pinkA200,
    accent2Color: _colors.grey100,
    accent3Color: _colors.grey500,
    textColor: _colors.darkBlack,
    alternateTextColor: _colors.white,
    canvasColor: _colors.white,
    borderColor: _colors.grey300,
    disabledColor: (0, _colorManipulator.fade)(_colors.darkBlack, 0.3),
    pickerHeaderColor: _colors.cyan500
  }
};

function count() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];

  switch (action.type) {
    case _actions.SET_THEME:
      return action.payload;
    default:
      return state;
  }
}


/*****************
 ** WEBPACK FOOTER
 ** ./~/@its/components/lib/Container components/MuiThemeProviderContainer/reducer.js
 ** module id = 476
 ** module chunks = 0
 **/